import React from 'react'
import { Layout } from "../../../componentsV1/layout";
import css from './ip.module.scss'
import Logo from "../../../assets/v1/logo.png";
import { Antibody, Stack, Graph, Target, Validation } from "../../../assets/v1/icons";


export const IntellectualProperty = () => {

    const logos = [
        {
            icon: Target,
            text: "Resolution Aware"
        },
        {
            icon: Stack,
            text: "Systematic Progression"
        },
        {
            icon: Validation,
            text: "Biologically Validated"
        },
        {
            icon: Graph,
            text: "Actionable Insights"
        }
    ]

    return (
        <Layout>
            <div className={css.heroContainer}>
                <div className={css.heroContent}>
                    <img src={Logo} alt="logo" className={css.heroLogo} />
                    <div className={css.heroText}>
                        <h1>INTELLECTUAL <br /> PROPERTY</h1>
                        <div className={css.line} />
                        <p>Patented innovations across AI-powered design, step-down microscopy, and conjugation chemistry that unlock resolution, clarity, and clinical impact.</p>
                    </div>
                    <div className={css.logoContainer}>
                        {logos.map((item) => {
                            return (
                                <div className={css.logo}>
                                    <img src={item.icon} alt={item.text} />
                                    <p>{item.text}</p>
                                </div>
                            )
                        })
                        }
                    </div>
                </div>
            </div>
            <div className={css.container}>
                <div className={css.legalSection}>

                    <h2>Identifyn® Intellectual Property Program</h2>
                    <p>Identifyn® maintains a comprehensive and forward-thinking intellectual property (IP) program to protect our core innovations across multimodal imaging, advanced software tools, and scientific data generation in the life sciences. Our IP strategy ensures the security, commercial viability, and scientific integrity of our technologies, while supporting collaboration with academic and industry partners.</p>
                    <h3>Core IP Protections</h3>
                    <h5>Trademarks</h5>
                    <p>We actively manage a robust trademark portfolio that protects our brand identity and proprietary technologies across markets and platforms.</p>
                    <p><strong>Current trademark registrations include:</strong></p>
                    <ul>
                        <li><em>Identifyn® (word mark) — 7886036</em></li>
                        <li><em>Identifyn® logo</em></li>
                        <li><em>Bennett Standards for Optical Microscopy™</em></li>
                    </ul>
                    <h5>Copyright Protection</h5>
                    <p>All microscopy images, super-resolution visualizations, and experimental datasets generated within the Identifyn® platform are individually protected under copyright. Every image produced in our product search category carries its own copyright registration.</p>
                    <p>As of <strong>July 2025</strong>, Identifyn® holds <strong>over 1,500 individual copyright-protected data records.</strong></p>
                    <h5>Design Patents</h5>
                    <p>Identifyn® protects the unique design and user interface of our digital tools through active design patent filings. These applications cover specialized graphical user interfaces (GUIs) used in our AI-driven platforms.</p>
                    <div>
                        <p><strong>Pending Design Patent Applications:</strong></p>
                        <ul>
                            <li><em>Display Screen or Portion Thereof For Fluorescence Curves With a Graphical User Interface — 29/942,013</em></li>
                            <li><em>Computing Device Display Screen With SSB Pathway Graphical User Interface — 29/987,869</em></li>
                            <li><em>Computing Device Display Screen With NHEJ Graphical User Interface — 29/987,872</em></li>
                            <li><em>Computing Device Display Screen With HR Graphical User Interface — 29/987,873</em></li>
                            <li><em>Computing Device Display Screen With Product Gallery Graphical User Interface — 29/987,874</em></li>
                        </ul>
                    </div>
                    <h5>Utility Patent Filings</h5>
                    <p>Our utility patent portfolio secures the fundamental scientific and software-driven innovations developed by Identifyn®. These filings encompass methods, systems, and chemistries foundational to our research platforms:</p>
                    <div>
                        <p><strong>Filed Utility Patents Include:</strong></p>
                        <ul>
                            <li><em>Systems for Cellular Experiment Design (AI-assisted RUO assay design tools)</em></li>
                            <li><em>Methods for Resolution Walkdown Microscopy (multimodal step-down integration of super-resolution and diffraction-limited imaging)</em></li>
                            <li><em>Step-Down Microscopy in Patient-Targeted, Individualized Treatment (precision diagnostics and therapeutic planning using multi-scale molecular imaging)</em></li>
                            <li><em>Advanced Fluorescent Conjugation Chemistry (enabling enhanced resolution, photostability, and signal clarity in biological imaging)</em></li>
                        </ul>
                    </div>
                    <h5>Academic Access</h5>
                    <p>Identifyn® supports scientific discovery by offering <strong>approved academic researchers access to our proprietary image libraries and datasets at no cost.</strong> These collaborations are made available strictly for <strong>non-commercial research purposes</strong> and enable peer-reviewed publication and high-impact experimentation.</p>
                    <h5>Commercial Licensing Opportunities</h5>
                    <p>Identifyn® offers structured licensing agreements for commercial partners seeking access to our patented technologies, including our software platforms, proprietary chemistries and reagents, advanced imaging methods, and Identifyn® data. These licenses are designed to ensure responsible use while maintaining innovation quality and integrity.</p>
                    <p>Through this integrated intellectual property program, Identifyn® secures the foundations of its scientific leadership, supports global research efforts, and enables the responsible commercialization of next-generation imaging tools and data science solutions.</p>
                    <p>For information on Identifyn® Intellectual Property: contact@identifyn.com or (941) 529-0647</p>
                </div>
            </div>
        </Layout>
    )
}